import React from 'react';
import { YAText } from '@ui-kit';
import { useNavigate } from 'react-router-dom';

import './Home.style.scss';
import { menu_list } from '@config/menu-config';

const Home = () => {
  const navigate = useNavigate();

  return (
    <div className={'home-page'}>
      <YAText text={'YARO ART'} type={'logo'} />
      <div className={'home-page-content'}>
        {menu_list.map((item, index) => (
          <YAText key={index} text={item.text} type={'H0'} onClick={() => navigate(item.path)} />
        ))}
      </div>
    </div>
  );
};

export default Home;
